import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import {IconsModule} from '../../icons/icons.module';
import { ApproveDialogComponent } from './approve-dialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ErrorModule } from '../error/error.module';

@NgModule({
  declarations: [ApproveDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule
  ]
})
export class ApproveDialogModule {
}

